"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getDesktopSize = require("./getDesktopSize");
Object.keys(_getDesktopSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDesktopSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDesktopSize[key];
    }
  });
});
//# sourceMappingURL=index.js.map